import { createColor } from 'material-ui-color';

export const textPalette = {
  red: createColor('#ff0000'),
  blue: createColor('#0000ff'),
  green: createColor('#00ff00'),
  yellow: createColor('yellow'),
  cyan: createColor('cyan'),
  lime: createColor('lime'),
  black: createColor('black'),
  white: createColor('white'),
};

export const backgroundPalette = {
  black: createColor('black'),
  white: createColor('white'),
};
